(() => {
  const MIN_CENTS = 28000;

  async function updateMinOrderUI() {
    const wrap = document.querySelector('.min-order-wrap');
    const drawer = document.querySelector('cart-drawer');
    const form = document.querySelector('#CartDrawer-Form');

    if (!wrap || !drawer || !form) return;

    const lang = wrap.dataset.lang || 'en';
    const isArabic = lang === 'ar' || lang.startsWith('ar-');

    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
    const total = Number(cart.total_price || 0);

    const checkoutBtn = drawer.querySelector('#CartDrawer-Checkout');

    const formatMoney = (cents) =>
      window.Shopify?.formatMoney ? Shopify.formatMoney(cents) : (cents / 100).toFixed(2);

    if (total < MIN_CENTS) {
      const remaining = MIN_CENTS - total;

      wrap.innerHTML = isArabic
        ? `<p class="min-order-text">الحد الأدنى للطلب هو <strong>${formatMoney(MIN_CENTS)}</strong>. أضف <strong>${formatMoney(remaining)}</strong> لإتمام الطلب.</p>`
        : `<p class="min-order-text">Minimum order is <strong>${formatMoney(MIN_CENTS)}</strong>. Add <strong>${formatMoney(remaining)}</strong> more to checkout.</p>`;

      if (checkoutBtn) {
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('aria-disabled', 'true');
        checkoutBtn.classList.add('is-disabled');
      }

      // Hard stop submit
      form.onsubmit = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      };
    } else {
      wrap.innerHTML = isArabic
        ? `<p class="min-order-text min-order-ok">✅ لقد وصلت إلى الحد الأدنى للطلب، يمكنك المتابعة للدفع الآن.</p>`
        : `<p class="min-order-text min-order-ok">✅ You reached the minimum order. You can checkout now.</p>`;

      if (checkoutBtn) {
        checkoutBtn.disabled = false;
        checkoutBtn.removeAttribute('aria-disabled');
        checkoutBtn.classList.remove('is-disabled');
      }

      form.onsubmit = null;
    }
  }

  document.addEventListener('DOMContentLoaded', updateMinOrderUI);

  const observer = new MutationObserver(updateMinOrderUI);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
